// ----------------------------------------------------------------------
// <copyright file="Izenda.DashboardPartViewer.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Dashboard Part Viewer component
 */

/**
 * This component is intended to show only dashboard part content.
 * Parameters locate in the params property.
 * id: required. Id of report part
 *
 * Example build URI:
 * var ContentRoutes = require('routes/Izenda.ContentRoutes').contentRoutes;
 * var ROUTE = require('routes/Izenda.ContentRoutes').route;
 * var uri = routeUtils.getViewerUrl(
 *   'DashboardPart',
 *   {
 *     id: '00867012-9060-4347-8460-ac41aa3291f2'
 *   }
 * );
 * // result: /viewer/dashboardpart/00867012-9060-4347-8460-ac41aa3291f2
 */

!(function() {
  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var DashboardPartStore = require('logic/Izenda.DashboardPartStore');
  var DashboardTile = require('modules/Dashboard/DashboardDesigner/DashboardGrid/DashboardTile/Izenda.DashboardTile');
  const { isNil } = require('lodash/fp');

  var DashboardPartViewer = React.createClass({
    propTypes: {
      params: React.PropTypes.object
    },

    getInitialState: function() {
      return {
        part: null,
        sourceStore: null
      };
    },

    componentWillMount: function() {
      this.store = new DashboardPartStore();
    },

    componentDidMount: function() {
      var props = this.props;
      var loader = props.loader;
      var params = props.params;
      
      loader.startLoading();
      this.store
        .loadReportPartContentFromDashboard(params.id)
        .then(
          function(result) {
            this.setState({
              part: result.part,
              sourceStore: result.sourceStore
            });
          }.bind(this)
        )
        .finally(loader.endLoading.bind(loader));
    },

    render: function() {
      var state = this.state;
      var dashboardPart = state.part;
      var sourceStore = state.sourceStore;

      return !isNil(dashboardPart) ? (
        <DashboardTile dashboardPart={dashboardPart} viewMode store={sourceStore} printingMode />
      ) : null;
    }
  });

  module.exports = connect()(DashboardPartViewer);
})();



// WEBPACK FOOTER //
// ./ui/share/components/views/Izenda.DashboardPartViewer.jsx